<template>
<header class="tl-header">
  <div class="tl-top-headline d-none d-lg-block">
    <div class="container">
      <div class="tl-top-headline__row">
        <div class="tl-top-headline__submenu tl-submenu">
          <a
            v-for="item in submenu"
            :key="item.text"
            class="tl-submenu__item"
            :href="item.href"
          >
            {{ item.text }}
          </a>
        </div>
        <div class="tl-top-headline__menu">
          <div class="tl-menu">
            <template
              v-for="(item, i) in menu"
            >
                <span
                  v-if="i !== 0"
                  :key="i"
                >&nbsp;|&nbsp;</span>
              <a
                :key="item.text"
                class="tl-menu__item"
                :class="{
                  'tl-menu__item_active': item.active,
                }"
                :href="item.href"
              >{{ item.text }}</a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tl-headline">
    <div class="container container_p-sm">
      <div class="tl-headline__row">
        <div class="tl-headline__item tl-headline__menu-btn d-lg-none">
          <RrButton
            variant="clear"
            shape="circle"
            icon-left="menu"
            icon-size="xl"
            @click="openMobileNav"
          ></RrButton>
        </div>
        <a class="tl-headline__item tl-headline__logo" href="https://topliga.ru/">
          <img src="@/assets/img/tenants/topliga2/logo.png" alt="Высшая Лига">
        </a>
        <div class="tl-headline__item tl-headline__user">
          <RrButton
            variant="clear"
            shape="circle"
            @click="login"
          >
            <Avatar
              :username="user && user.fullName"
              :img="user && user.avatarSmallUrl"
              bordered
            ></Avatar>
          </RrButton>
        </div>
      </div>
    </div>
  </div>
  <HeaderMobileNav
    v-model="mobileNavOpened"
    :nav="mobileNav"
  >
    <template v-slot:logo>
      <a href="https://topliga.ru/" class="rr-mobile-nav__logo">
        <img src="@/assets/img/tenants/topliga2/logo.png" alt="" width="185">
      </a>
    </template>
  </HeaderMobileNav>
</header>
</template>

<script>
import Avatar from '@/components/Avatar.vue'
import RrButton from '@rr-component-library/button/src/main'
import HeaderMobileNav from '@/components/Header/HeaderMobileNav.vue'
import { mapState } from 'vuex'

export default {
  name: 'HeaderTopliga',
  components: {
    Avatar,
    RrButton,
    HeaderMobileNav
  },
  data () {
    return {
      mobileNavOpened: false,
      submenu: [
        {
          text: 'Контакты',
          href: 'https://topliga.ru/company/contacts/'
        }
      ],
      menu: [
        {
          text: 'Старты',
          href: this.$getEnvVar('VUE_APP_RR_URL'),
          icon: 'calendar'
        },
        {
          text: 'Результаты',
          href: this.$getEnvVar('VUE_APP_RESULTS_URL'),
          icon: '1st-place-medal'
        },
        {
          text: 'Фото',
          href: 'https://photo.topliga.ru/',
          icon: 'camera'
        },
        {
          text: 'Клубы',
          href: 'https://topliga.ru/clubs',
          icon: 'user-groups',
          active: true
        },
        {
          text: 'Магазин',
          href: 'https://topliga.ru/',
          icon: 'shopping-bag'
        },
        {
          text: 'Партнерам',
          href: 'https://topliga.ru/partners',
          icon: 'empty-flag'
        },
        {
          text: 'Корпоративное участие',
          href: 'https://topliga.ru/corp',
          icon: 'business'
        }
      ]
    }
  },
  computed: {
    ...mapState('user', ['user', 'isAuthorized']),
    mobileNav () {
      return [
        ...this.menu,
        { divider: true },
        ...this.submenu
      ]
    }
  },
  methods: {
    openMobileNav () {
      this.mobileNavOpened = true
    },
    login () {
      const returnUrl = `${window.location.origin}${this.$route.path}`
      const domain = this.$getEnvVar('VUE_APP_RR_URL')
      const url = !this.isAuthorized
        ? `${domain}login?returnUrl=${returnUrl}`
        : `${domain}Account`
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
.tl-header {
  position: relative;
  z-index: 99;
}

.tl-top-headline {
  background-color: #ECF0F3;

  &__row {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__submenu {
    flex: 0 0 auto;
  }

  &__menu {
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 40px;
  }
}

.tl-submenu {
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;

  &__item {
    flex: 0 0 auto;
    color: #4E4E4E;
    text-decoration: none;
    outline: none;

    & + & {
      margin-left: 16px;
    }

    &:hover, &:active, &:focus {
      color: #00489a;
    }
  }
}

.tl-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  width: 752px;
  max-width: 100%;
  margin-left: auto;

  &__item {
    position: relative;
    display: block;
    flex: 0 0 auto;
    font-size: 13px;
    line-height: 22px;
    font-weight: bold;
    color: #000000;
    text-transform: uppercase;
    text-decoration: none;
    outline: none;

    &:hover, &:active, &:focus {
      color: #00489a;
    }

    &_active {

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 3px;
        margin-top: 2px;
        background: $gradient-horizontal-primary;
      }
    }
  }
}

.tl-headline {
  background-color: $color-white;

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;

    @media (min-width: breakpoint(md)) {
      height: 64px;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    flex: 1 1 0;

    @media (min-width: breakpoint(lg)) {
      flex: 0 0 auto;
    }
  }

  &__logo {
    flex: 0 0 auto;
    width: 185px;

    @media (min-width: breakpoint(md)) {
      width: 248px;
    }
  }

  &__user {
    justify-content: flex-end;
  }
}
</style>
